<template>
  <div class="ambassadors-menu-banner" role="button" tabindex="0" @click="$emit('click')"
       @keyup.enter="$emit('click')" @keydown.space.prevent="$emit('click')">
    <div class="texts">
      <div class="title ri-bold-label">להמליץ ולהרוויח</div>
      <div class="subtitle">עד 150 ₪ על כל חברה<br/>או חבר שיגיעו דרכך</div>
    </div>
    <div class="illustration">
      <img class="eyes" :src="require('@/assets/icons/navigation-menu/banner-eyes.svg')" alt=""/>
      <img class="growth" :src="require('@/assets/icons/navigation-menu/banner-growth.png')" alt=""/>
    </div>
    <img class="arrow" :src="require('@/assets/icons/navigation-menu/banner-arrow.svg')" alt=""/>
  </div>
</template>

<script>
export default {
  name: 'AmbassadorsMenuBanner',
};
</script>

<style scoped lang="scss">
@import '~@riseupil/base-ui/src/scss/riseup-colors';

.ambassadors-menu-banner {
  position: relative;
  height: 80px;
  overflow: hidden;
  border-radius: 24px;
  border: 1px solid rgba(32, 33, 37, 0.08);
  background: #E8F4BA;
  color: $riseup_black;
  cursor: pointer;

  .texts {
    position: relative;
    z-index: 1;
    padding: 11px 19px 0 0;
  }

  .title {
    letter-spacing: -0.14px;
  }

  .subtitle {
    font-size: 14px;
    line-height: 18px;
    opacity: 0.5;
  }

  .illustration {
    position: absolute;
    top: -1px;
    left: -1px;
    width: 154px;
    height: 80px;
    overflow: hidden;

    .eyes {
      position: absolute;
      top: 6px;
      left: 43px;
      width: 108px;
      height: 68px;
    }

    .growth {
      position: absolute;
      top: 15px;
      left: 43.5px;
      width: 119px;
      height: 67px;
      object-fit: cover;
    }
  }

  .arrow {
    position: absolute;
    top: 31px;
    left: 19px;
    width: 15px;
    height: 15px;
  }
}

// The Figma card is 321px wide (a 410px screen); shrink the art on narrower phones so it keeps clear of the text
@media (max-width: 409px) {
  .ambassadors-menu-banner .illustration {
    transform: scale(0.9);
    transform-origin: 45px 50%;
  }
}

@media (max-width: 384px) {
  .ambassadors-menu-banner .illustration {
    transform: scale(0.8);
    transform-origin: 50px 50%;
  }
}
</style>
